import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyHome = lazy(async () => await import('./home'));

export const HomeRouter: RouteObject = {
  path: '',
  index: true,
  element: <LazyHome />
};
